<ng-container *ngFor="let itemType of itemsByFamily">
	<div class="card m-4">
		<div class="d-flex">
			<div class="display-6 ms-1 mt-2 mb-1">{{ itemType.label }}</div>
			<div class="display-6 ms-auto" *ngIf="!quoteService.quote.value.FocusCloudPlus__c">
				{{ itemType.total | currency }}
				<span *ngIf="itemType.type === 'Monthly'" class="product-item-meta">/month</span>
			</div>
		</div>
		<p-divider></p-divider>
		<p-table #dt styleClass="p-datatable-responsive-demo p-datatable-striped" [value]="itemType.items" [globalFilterFields]="app.keys(itemType.items)">
			<ng-template pTemplate="caption">
				<div class="d-flex item-family-description">
					{{ itemType.descriptionHeader }}
				</div>
			</ng-template>

			<ng-template let-rec pTemplate="body">
				<tr>
					<td>
						<div class="d-flex flex-column w-100">
							<div class="p-grid">
								<div class="p-col line-item-description d-flex" (click)="rec.viewItemDetail = !rec.viewItemDetail">
									{{ rec.Item_Description__c }}
									<div class="ms-auto line-item-description" *ngIf="!quoteService.quote.value.FocusCloudPlus__c">
										{{ rec.Extended_Price__c | currency }}
									</div>
								</div>
							</div>
							<div class="p-grid">
								<div class="p-col-12 line-item-meta ms-4 d-flex w-100">
									<div *ngIf="!quoteService.quote.value.FocusCloudPlus__c">
										{{ rec.Quantity }} at {{ rec.UnitPrice | currency }} each
										<span *ngIf="rec.Discount" class="italic">&nbsp;discount {{ rec.Discount_Friendly__c }}</span>
									</div>

									<div class="ms-auto me-4 italic" *ngIf="rec.Product2.Availability__c">availability {{ rec.Product2.Availability__c }}</div>
								</div>
							</div>
							<div *ngIf="rec.viewItemDetail" class="animation-flip-in-hor-bottom animate-duration-200ms">
								<div class="d-flex flex-wrap">
									<div class="ms-2" *ngIf="rec.Product2.Product_Image_Link__c || rec.Product2.DisplayUrl">
										<img
											*ngIf="rec.Product2.DisplayUrl"
											src="{{ rec.Product2.DisplayUrl }}"
											alt="{{ rec.Product2.Name }}"
											class="product-image"
										/>
										<img
											*ngIf="rec.Product2.Product_Image_Link__c && !rec.Product2.DisplayUrl"
											src="https://focusca--c.na23.content.force.com/servlet/servlet.FileDownload?file={{
												rec.Product2.Product_Image_Link__c
											}}"
											alt="{{ rec.Product2.Name }}"
											class="product-image"
										/>
									</div>
									<div class="ms-2 my-auto d-flex flex-column">
										<div class="display-6">
											{{ rec.Item_Description__c }}
										</div>
									</div>
									<div class="m-2 d-flex flex-column">
										<div *ngIf="rec.Product2.Detailed_Description__c" class="item-detailed-description">
											{{ rec.Product2.Detailed_Description__c }}
										</div>
										<div *ngIf="rec.Product2.Mfr_Warranty_Term__c" class="item-detailed-description">
											manufacturer's warranty {{ rec.Product2.Mfr_Warranty_Term__c }} months
										</div>
										<div class="ms-auto" *ngIf="rec.Product2.Knowledge_URL__c">
											<a href="{{ rec.Product2.Knowledge_URL__c }}" target="_blank">More info...</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</ng-container>
